module.exports = new __parcel__URL__("smashing-plates.7136aa41.webp").toString();